export const platformChannelLabels: Record<string, string[]> = {
  xiaohongshu: ["xiaohongshu", "小红书"], wechat_official: ["wechat_official", "公众号", "微信公众号", "微信公众"],
  wechat_moments: ["wechat_moments", "朋友圈"], wechat_group: ["wechat_group", "社群", "微信群"],
  douyin: ["douyin", "抖音"], wechat_channels: ["wechat_channels", "视频号", "微信视频号"]
};

export type GenerationChannel = {
  id: string;
  name?: string;
  platform: string;
  status: string;
  account_name?: string;
};

const normalizedPlatform = (value: unknown) => String(value ?? "").trim().toLowerCase();

export function channelsForGenerationPlatform(platform: string, channels: GenerationChannel[]) {
  const labels = platformChannelLabels[platform] || [];
  return channels
    .filter((channel) => channel.status === "active" && labels.includes(normalizedPlatform(channel.platform)))
    .sort((left, right) => Number(normalizedPlatform(right.platform) === platform) - Number(normalizedPlatform(left.platform) === platform)
      || String(left.name || left.id).localeCompare(String(right.name || right.id), "zh-CN"));
}

export function defaultGenerationChannelIds(
  platforms: string[],
  channels: GenerationChannel[],
  current: Record<string, string> = {}
) {
  const result: Record<string, string> = {};
  for (const platform of platforms) {
    const candidates = channelsForGenerationPlatform(platform, channels);
    const selected = current[platform];
    if (selected && candidates.some((channel) => channel.id === selected)) result[platform] = selected;
    else if (candidates.length === 1) result[platform] = candidates[0].id;
  }
  return result;
}

export function selectedGenerationChannelIds(
  platforms: string[],
  selected: Record<string, string>,
  channels: GenerationChannel[]
) {
  const result: Record<string, string> = {};
  for (const platform of platforms) {
    const candidates = channelsForGenerationPlatform(platform, channels);
    if (!candidates.length) throw new Error(`“${platform}”没有已启用的发布渠道，请先创建或启用渠道`);
    const channelId = selected[platform];
    if (!channelId) {
      if (candidates.length === 1) result[platform] = candidates[0].id;
      else throw new Error(`请选择“${platform}”的发布渠道`);
      continue;
    }
    if (!candidates.some((channel) => channel.id === channelId)) throw new Error(`“${platform}”所选渠道不存在、已停用或不属于该平台，请重新选择`);
    result[platform] = channelId;
  }
  return result;
}

// 保留旧调用兼容：新建内容页面应优先使用 selectedGenerationChannelIds 尊重用户显式选择。
export function generationChannelIds(platforms: string[], channels: GenerationChannel[], account: { channel_id: string } | null) {
  const result: Record<string, string> = {};
  for (const platform of platforms) {
    const candidates = channelsForGenerationPlatform(platform, channels);
    if (platform === "xiaohongshu" && account) {
      if (!candidates.some((channel) => channel.id === account.channel_id)) throw new Error("当前绑定账号的渠道不存在、已停用或列表已过期，请刷新页面后重试");
      result[platform] = account.channel_id;
    } else if (candidates[0]) result[platform] = candidates[0].id;
  }
  return result;
}
